module.exports = __webpack_public_path__ + "img/wanliu.2577b8b0.png";